export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAIL = 'GET_ROLES_FAIL';
export function getRolesRequest(data) {
  return {
    type: GET_ROLES_REQUEST,
    payload: data,
  };
}
